export default __webpack_public_path__ + "static/media/gims.5f30db32.jpg";